import { useSelector } from 'react-redux'

import { UserState } from '../redux/features/user/userSlice'

type StoreWithUser = {
    user: UserState
}

export const useSessionUser = (): UserState => useSelector((state: StoreWithUser) => state.user)
